import * as Dialog from "@radix-ui/react-dialog";
import { useEffect, useState } from "react";
import useVolunteerShopList from "../../../Hooks/useVolunteerShopList";
import { toast } from "sonner";

export default function AssignVolunteerShopModal({
  isOpen,
  onClose,
  volunteer,
  onSuccess,
}) {
  const {
    volunteerShops,
    loading,
    fetchVolunteerShops,
    assignShopToVolunteer,
  } = useVolunteerShopList();

  const [selectedShopId, setSelectedShopId] = useState("");

  useEffect(() => {
    if (isOpen) {
      fetchVolunteerShops();
    }
  }, [isOpen]);

  const handleAssign = async () => {
    if (!selectedShopId) {
      toast.error("Please select a shop");
      return;
    }

    const success = await assignShopToVolunteer(
      volunteer.volunteer_code,
      selectedShopId,
    );

    if (success) {
      onSuccess();
    }
  };

  if (!isOpen || !volunteer) return null;

  return (
    <Dialog.Root open={isOpen} onOpenChange={onClose}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 bg-black/40 z-50" />
        <Dialog.Content className="bg-white rounded-md shadow-lg p-6 w-[90%] max-w-md fixed top-[50%] left-[50%] -translate-x-1/2 -translate-y-1/2 z-50">
          <Dialog.Title className="text-lg font-semibold mb-4">
            Assign Shop to {volunteer.first_name}
          </Dialog.Title>

          {/* Shop Dropdown */}
          <div className="border rounded-md mt-2 max-h-[250px] overflow-y-auto">
            {volunteerShops?.length === 0 ? (
              <div className="p-3 text-sm text-gray-500">
                No shops available
              </div>
            ) : (
              volunteerShops.map((shop) => (
                <div
                  key={shop.shop_id}
                  onClick={() => setSelectedShopId(shop.id)}
                  className={`px-3 py-2 text-sm cursor-pointer border-b hover:bg-gray-100 ${
                    selectedShopId === shop.id
                      ? "bg-blue-200 font-medium"
                      : ""
                  }`}
                >
                  {shop.shop_name}
                </div>
              ))
            )}
          </div>

          <div className="flex justify-end gap-2 mt-6">
            <button onClick={onClose} className="px-3 py-1 rounded bg-gray-200">
              Cancel
            </button>

            <button
              onClick={handleAssign}
              className="px-3 py-1 rounded bg-blue-600 text-white"
            >
              Assign
            </button>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
